export const dashboardEn: Record<string, string> = {
  'good_morning': 'Good morning',
  'good_afternoon': 'Good afternoon',
  'good_evening': 'Good evening',
  'there': 'there',
  'welcome_to_bridal_dashboard': 'Welcome to your bridal dashboard',
  'new_appointment': 'New Appointment',
  'total_leads': 'Total Leads',
  'customers': 'Customers',
  'total_in_pipeline': 'Total in pipeline',
  'registered_customers': 'Registered customers',
  'subtotal': 'Subtotal',
  'tailoring_cost': 'Tailoring Cost',
  'next_7_days': 'Next 7 days',
  'active_orders': 'Active Orders',
  'in_progress': 'In progress',
  'dashboard_total_revenue': 'Total Revenue',
  'dashboard_unrequested_amount': 'Unrequested',
  'dashboard_unpaid_balance': 'Unpaid Balance',
  'dashboard_across_all_orders': 'Across all orders',
  'dashboard_outstanding_payments': 'Outstanding payments',
  'dashboard_not_covered_by_requests': 'Not covered by requests',
  'recent_leads': 'Recent Leads',
  'latest_inquiries_from_potential_customers': 'Latest inquiries from potential customers',
  'view_all': 'View All',
  'no_stage': 'No Stage',
  'no_recent_leads': 'No recent leads',
  'todays_and_upcoming_scheduled_appointments': "Today's and upcoming scheduled appointments",
  'no_upcoming_appointments': 'No upcoming appointments',
  'quick_actions': 'Quick Actions',
  'common_tasks_to_get_started': 'Common tasks to get started',
  'add_lead': 'Add Lead',
  'new_customer': 'New Customer',
  'schedule_fitting': 'Schedule Fitting',
  'create_order': 'Create Order',
  'recent_activity': 'Recent Activity',
  'no_recent_activity': 'No recent activity',
  'book_appointment': 'Book Appointment',
  'view_wishlist': 'View Wishlist',
  'view_orders': 'View Orders',
  'contact_us': 'Contact Us',
  'share_qr_code': 'Share your code as QR',
  'wedding_countdown': 'Wedding Countdown',
  'days_until_wedding': 'days until your special day',
  'hours_until_wedding': 'hours until your special day',
  'minutes_until_wedding': 'minutes until your special day',
  'wedding_passed': 'Your special day has passed',
  'order_status': 'Order Status',
  'track_progress': 'Track your dress progress',
  'earn_points': 'Earn points and special rewards',
  'guides_tips': 'Guides and wedding planning tips',
  'latest_interactions': 'Your latest interactions with us',
  'visit_boutique': 'Visit our boutique for personalized assistance',
  'get_in_touch': 'Get in touch with our team',
  'dream_dress_journey': 'Your dream dress journey continues here',
  'congratulations_wedding': 'Congratulations on your wedding day!',
  'view_manage_fittings': 'View and manage your upcoming fittings',
  'favorite_dresses': 'Your favorite dresses and inspiration',
  'dashboard.featureComingSoon': 'This feature will be available soon!',
};
